<template>
    <div class="collectionForm">
        <div class="containerMD">
      <div class="info-container">
      <div class="info-content smLabel">
        <p class="inputLabel">Enter number of floors of your building.</p>
                <el-input
                :placeholder="'Enter Floors (1-50)'"
                v-model.number="infoFormData.floorValue"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    infoFormData.floorValue,
                    'floorValue')"
                class="no-arrow-buttons"
                @keydown="preventSpecialCharacters"
              >
              <template #append>
                  <div>
                    <span></span>
                  </div>
                </template>
              </el-input>
        <div
        v-if="errorData.floorValue"
        class="warning"
      >
      Should be between 1 and 50.
      </div>
      </div>
      <div  class="info-content">
        <p class="inputLabel mdLabel">Power Supply Phase</p>
        <el-radio-group
              v-model="infoFormData.supply_phase"
              @change="
            handleInputValueChange(
              infoFormData.supply_phase,
              'supply_phase')"
            >
              <el-radio
                label="Single Phase"
                :disabled="disableRadio.isSingleDisabled"
                >{{ 'Single Phase' }}</el-radio>
                <el-radio
                label="Three Phase"
                :disabled="disableRadio.isThreeDisabled"

                >{{ 'Three Phase' }}</el-radio>
            </el-radio-group>
       
      </div>
      <div  class="info-content">
        <p class="inputLabel mdLabel">Tariff Rate</p>
        <div class="tariff-container">
          <div class="tariff-slider">
            <div class="tariff-range-min">4</div>
            <el-slider
            v-model="infoFormData.tariff_rate"
            @input=" handleInputValueChange(
                    infoFormData.tariff_rate,
                    'tariff_rate')"
            :min="4"
            :max="30"
            class="custom-slider"
            :tooltip-class="'custom-slider-tooltip'" 
          >
          </el-slider>
          <div class="tariff-range-max">30</div>
          </div>
      
          <div class="tariff-input">
            <div class="triff-inc-dec"  @click="tariffIncrementDecrement('decrease')"><b-icon icon="dash"></b-icon>
            </div>
            <div class="tariff-input-box">
              <input
                type="number"
                v-model="inputTariffValue"
                class="time_input"
                @input="handleTariffChange()"
                :controls="false"
                @keydown="preventSpecialCharacters"
              />
              <p style="margin-left: auto" class="unit_text">INR</p>
            </div>
            <div class="triff-inc-dec" @click="tariffIncrementDecrement('increase')"><b-icon icon="plus"></b-icon></div>

          </div>
        </div>
      
        
       
      </div>
      <div  class="info-content">
        <p class="inputLabel smLabel">Monthly Electricity Bill</p>
        <el-input
                :placeholder="'1000'"
                v-model.number="infoFormData.monthly_bill"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    infoFormData.monthly_bill,
                    'monthly_bill')"
                class="no-arrow-buttons"
                @keydown="preventSpecialCharacters"
              >
                <template #append>
                  <div>
                    <span>{{ 'INR' }}</span>
                  </div>
                </template>
              </el-input>
              <div
        v-if="errorData.monthly_bill"
        class="warning"
      >
        Maximum rooftop area limit is 9999999.
      </div>
      <div
        v-if="errorData.monthly_bill_min"
        class="warning"
      >
        Should be greater than or equal than 10000.
      </div>
      </div>
      <div  class="info-content">
        <p class="inputLabel smLabel">Sanction Load</p>
        <el-input
                :placeholder="'5'"
                v-model.number="infoFormData.sanction_load"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    infoFormData.sanction_load,
                    'sanction_load',
                  )
                "
                class="no-arrow-buttons"
                @keydown="preventSpecialCharacters"
              >
                <template #append>
                  <div>
                    <span>{{ 'KW' }}</span>
                  </div>
                </template>
              </el-input>
              <div
        v-if="errorData.sanction_load"
        class="warning"
      >
      Should be between 1 and 100.
      </div>
       
      </div>
    </div>
      <el-button 
      v-show="isFooter"
        type="primary" 
        class="drwBtnBtnMD" 
        :disabled="!checkDrawRoofDisabled" 
        @click="setInfoFormDataToStore">
      Draw Roof</el-button>
    </div>
    </div>
</template>

<script>
import { useStudioStore } from '../store/studioStore';
import {FLOOR_STATE, DRAWING_STATE, defaultComponentsData } from "./constants";
import { mapState,mapActions } from 'pinia';

    export default {
        data(){
            return {
                studioStore: useStudioStore(),
      inputTariffValue: 7,
      errorData:{
        monthly_bill:false,
        sanction_load:false,
        floorValue:false,
        monthly_bill_min:false,
      },
      disableRadio:{
        isThreeDisabled:false,
        isSingleDisabled:false
      },

            }
        },
        mounted(){
            const appState = localStorage.getItem('currentAppState');
    let componentData = localStorage.getItem('componentData');
    if (componentData) {
      componentData = JSON.parse(componentData);
      this.infoFormData=componentData?.infoData||this.infoFormData;
      this.$stageInstance.floorValue = this.infoFormData?.floorValue||null;
      if(this.infoFormData?.sanction_load){
        if(this.infoFormData?.sanction_load<=3){
          this.disableRadio.isSingleDisabled=false;
          this.disableRadio.isThreeDisabled=true;
        }else if(this.infoFormData?.sanction_load>5){
          this.disableRadio.isSingleDisabled=true;
          this.disableRadio.isThreeDisabled=false;
        }else{
          this.disableRadio.isSingleDisabled=false;
          this.disableRadio.isThreeDisabled=false;
        }
      }
    }


        },
        props:{
          isFooter:{
            type: Boolean,
            default: true,
          },
          formBtnDisabled:{
            type: Boolean,
            default: true,
          }

        },
        computed:{
          ...mapState(useStudioStore, {
            infoFormData: (state) => state.infoFormData,
    }),
            currentAppState() {
      return this.studioStore.currentAppState;
    },
            checkDrawRoofDisabled() {
      const errorData={};
// Check if all values are provided
for (const key in this.infoFormData) {
  if (this.infoFormData[key] === null || this.infoFormData[key] === '' || this.infoFormData[key] === undefined) {
    errorData[key]=true;
  }else{
    errorData[key]=false;
  }
}
if(Object.values(errorData).every(value => value === false)){
  // Validate specific fields with range constraints
  if(this.infoFormData.floorValue && parseInt(this.infoFormData.floorValue) && this.infoFormData.floorValue<0 && this.infoFormData.floorValue>50) {
    errorData.floorValue = true;
        }else{
          errorData.floorValue = false;
        }
  if (this.infoFormData.sanction_load !== null && (parseInt(this.infoFormData.sanction_load)<1 || parseInt(this.infoFormData.sanction_load )>100)) {
    errorData.sanction_load = true;
  }else{
   errorData.sanction_load = false;
}
 if(this.infoFormData.monthly_bill !== null && (parseInt(this.infoFormData.monthly_bill)<1 || parseInt(this.infoFormData.monthly_bill )>9999999)){
  errorData.monthly_bill = true;
 }else if(parseInt(this.infoFormData.monthly_bill)<1000){
  errorData.monthly_bill_min = true;
 }
 else{
  errorData.monthly_bill = false;
  errorData.monthly_bill_min = false;
 }
}
const anyTrue = Object.values(errorData).every(value => value === false);
this.$emit('updateBtnStatus', anyTrue);
return anyTrue; // Validation passed
    },

        },
        methods:{
          ...mapActions(useStudioStore, {
      setInfoFormData: "UPDATE_INFORMATION_FORM",
      setInfoFormDataToStore: "SET_INFORMATION_FORM_DATA_STORE",

    }),
            handleInputValueChange(value,label){
      try{
        if(label === 'floorValue'){
          this.$stageInstance.floorValue = value;
          if(this.infoFormData.floorValue && parseInt(this.infoFormData.floorValue) && (this.infoFormData.floorValue<0 || this.infoFormData.floorValue>50)) {
      this.errorData.floorValue = true;
          }else{
            this.errorData.floorValue = false;
          }
        }
        if(label === 'tariff_rate'){
          this.inputTariffValue = this.infoFormData.tariff_rate;
        }
        if(label === 'supply_phase'){
          this.infoFormData.supply_phase = value;
        }
        if(label === 'monthly_bill'){
          this.infoFormData.monthly_bill = value;
          if(this.infoFormData.monthly_bill !== null && (parseInt(this.infoFormData.monthly_bill)<1 || parseInt(this.infoFormData.monthly_bill )>9999999)){
    this.errorData.monthly_bill = true;
   }else if(parseInt(this.infoFormData.monthly_bill)<1000){
  this.errorData.monthly_bill_min = true;
 }else{
    this.errorData.monthly_bill = false;
    this.errorData.monthly_bill_min = false;

   }
        }
        if(label === 'sanction_load'){
        if(value)  {if(value<=3){
            this.infoFormData.supply_phase='Single Phase';
            this.disableRadio.isThreeDisabled=true;
            this.disableRadio.isSingleDisabled=false;

          }else if(value>5){
            this.infoFormData.supply_phase='Three Phase';
            this.disableRadio.isSingleDisabled=true;
            this.disableRadio.isThreeDisabled=false;
          }else{
            this.disableRadio.isSingleDisabled=false;
            this.disableRadio.isThreeDisabled=false;
          }}
          if (this.infoFormData.sanction_load !== null && (parseInt(this.infoFormData.sanction_load)<1 || parseInt(this.infoFormData.sanction_load )>100)) {
      this.errorData.sanction_load = true;
    }else{
     this.errorData.sanction_load = false;
  }
      }
      if(label === 'obstruction_height'){
        if(value<0.05||value>20){
          this.disableObstructionHeight=true;
      }else{
        this.disableObstructionHeight=false
        }
      }
      }catch(err){
        console.error('err: ', err);
      }

    },
    handleTariffChange(){
      this.infoFormData.tariff_rate = this.inputTariffValue;
    },
    tariffIncrementDecrement(trigger){
    if(trigger==='increase'){
      this.infoFormData.tariff_rate+=1;
      this.inputTariffValue+=1;
    }  
    if(trigger==='decrease'){
      this.infoFormData.tariff_rate-=1;
      this.inputTariffValue-=1;
    } 
  },
        },
        watch:{
          infoFormData:{
            handler(newVal) {
              this.setInfoFormData(newVal);
            },
            deep: true,
          },
        },
        
    }
</script>

<style scoped>
.layerParentContainer>.containerMD :deep() .el-slider__bar {
    width: 6px;
    background: #006eaf !important;
  }
  .layerParentContainer>.containerMD :deep() .el-slider__button {
  border: 3px solid var(--White, #fff);
  background: var(--Primary, #006eaf);
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  height: 15px;
  width: 15px;
}
.layerParentContainer>.containerMD :deep() .el-slider__runway {
 background-color: #ccc !important;
 width: 6px;
}
  .tariff-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tariff-input{ 
    display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
  }
  .tariff-input-box {
  border-radius: 4px;
  border: 1px solid var(--999, #999);
  background: var(--White, #fff);
  width: 80px;
  padding: 5px;
  display: flex;
  align-items: center;
  height: 40px;
}
.time_input {
  outline: none;
  border: none;
  width: 30px;
}
.tariff-slider{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.tariff-range-max{
  width: 36px;
}
.tariff-range-min{
  width: auto;
}
.triff-inc-dec{
  display: flex;
  justify-content: center;
  align-items: center;
 border-radius: 50%;
 border: 1px solid #222;
 width:16px;
 height: 16px;
 background-color: #222;
 color: #fff;
 font-size: 14px;
 font-weight: 600;
}
.layerParentContainer>.containerMD :deep() .el-input-group__append {
  box-shadow: none;
  background-color: white;
  padding: 0;
}
.layerParentContainer>.containerMD :deep() .el-input__inner {
  color: black;
  background-color: white !important;
}

.layerParentContainer>.containerMD :deep() .el-input__wrapper {
  box-shadow: none;
  padding-left: 1px;
}
.layerParentContainer>.containerMD :deep() .el-input-group{
  border:1px solid #777;
  padding: 8px 16px;
  border-radius: 4px;

}
.layerParentContainer>.containerMD :deep() .el-input__inner::placeholder{
  color: #777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;

}
.custom-slider-tooltip {
  background-color: #3498db !important;  /* Change background color */
  color: white !important;              /* Change text color */
  border-radius: 8px !important;        /* Add rounded corners */
  font-weight: bold !important;         /* Make text bold */
  padding: 5px 10px !important;         /* Adjust padding */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2) !important;
}
.layerParentContainer>.containerMD :deep() .el-radio__input.is-checked .el-radio__inner {
  border-color: #006eaf;
    background-color: #fff;
    border: 2px solid #006eaf;

}
.layerParentContainer>.containerMD :deep() .el-radio__inner::after {
  height: 7px;
  width: 7px;
  background-color: #006eaf;
  left: 50%;
  top: 50%;
}
.layerParentContainer :deep() .el-button.is-plain{
  background-color: none !important;

}
.layerParentContainer>.containerMD :deep() .el-radio__input.is-checked+.el-radio__label{
  color:#006eaf;
}
.warning{
  color:red;
  font-size: 12px;
}
.icon-container{
  background-color: #fff;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border:1px solid #ccc;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.selectedSolarAccess{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
    background-color:#006EAF;
    color: #fff;
    font-weight: 600;

}

.inputTag::placeholder{
  color:#777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}
.info-container{
  padding-bottom: 16px;
  display: grid;
  row-gap: 16px;
}
.info-content{
  display:grid;
  row-gap: 8px;
}
.smLabel{
    font-size: 12px;
  }
  .mdLabel{
    font-size: 14px;
  }


  .drwBtnBtnMD {
    font-size: 18px;
    font-weight: 600;
    padding: 13px 17px;
    height: 48px;
    width: 100vw;
    border-radius: 0px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.08);
    margin-left: -16px;
    font-family: "SegoeUI";
    background-color: var(--bgColor);
  }

  .drwBtnBtnMD:hover {
    background-color: var(--bgColor);
  }

  .drwBtnBtnMD.is-disabled, .drwBtnBtnMD.is-disabled:focus, .drwBtnBtnMD.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: none;
    border-top: 1px solid #ccc;
  }

</style>